module.exports = __webpack_public_path__ + "img/acne_ypgnbg_c_scale,w_1400.ad0f10cd.jpg";